import React from 'react';
import MinimumOffer from '../MinimumOffer';
import Countdown from '../Countdown';
import { UseAdoptableStateReturnType } from '../../../AdoptableInfo/useAdoptableState';
import s from './MinOfferAndCountdown.scss';

interface Props {
  adoptableState: UseAdoptableStateReturnType;
}

const MinOfferAndCountdown: React.FC<Props> = ({
  adoptableState: {
    isSeller,
    minOfferPrice,
    canSeeEarlyAccessCountdown,
    earlyAccessCountdownHasEnded,
    earlyAccessCountdownEndTime,
    onEarlyAccessTimerEnd,
    canSeeOfferCountdown,
    offerCountdownHasEnded,
    onOfferTimerEnd,
    offerCountdownEndTime,
  },
}) => {
  return (
    <div className={s['root']}>
      <MinimumOffer value={minOfferPrice} />

      <div role="presentation" className={s['divider']} />
      {(canSeeOfferCountdown || isSeller) && (
        <Countdown
          hasEnded={offerCountdownHasEnded}
          countToDate={offerCountdownEndTime!}
          onEnd={onOfferTimerEnd}
        />
      )}
      {!isSeller && canSeeEarlyAccessCountdown && (
        <Countdown
          isEarlyAccess
          hasEnded={earlyAccessCountdownHasEnded}
          countToDate={earlyAccessCountdownEndTime!}
          onEnd={onEarlyAccessTimerEnd}
        />
      )}
    </div>
  );
};

MinOfferAndCountdown.displayName = 'MinOfferAndCountdown';

export default MinOfferAndCountdown;
